import GTM from './lib/GTM';

export default GTM;
